var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2 4.5V10.5C4.2 10.9334 4.28536 11.3625 4.4512 11.7629C4.61704 12.1632 4.86011 12.527 5.16655 12.8335C5.47298 13.1399 5.83677 13.383 6.23714 13.5488C6.63752 13.7146 7.06664 13.8 7.5 13.8C7.93336 13.8 8.36248 13.7146 8.76286 13.5488C9.16323 13.383 9.52702 13.1399 9.83345 12.8335C10.1399 12.527 10.383 12.1632 10.5488 11.7629C10.7146 11.3625 10.8 10.9334 10.8 10.5V4.5C10.8 3.62479 10.4523 2.78542 9.83345 2.16655C9.21458 1.54768 8.37521 1.2 7.5 1.2C6.62479 1.2 5.78542 1.54768 5.16655 2.16655C4.54768 2.78542 4.2 3.62479 4.2 4.5ZM8.1 17.976V21H6.9V17.976C5.02078 17.8252 3.26728 16.9722 1.98864 15.5868C0.709989 14.2014 -9.68347e-06 12.3853 0 10.5V9H1.2V10.5C1.2 12.1709 1.86375 13.7733 3.04523 14.9548C4.22671 16.1363 5.82914 16.8 7.5 16.8C9.17086 16.8 10.7733 16.1363 11.9548 14.9548C13.1363 13.7733 13.8 12.1709 13.8 10.5V9H15V10.5C15 12.3853 14.29 14.2014 13.0114 15.5868C11.7327 16.9722 9.97922 17.8252 8.1 17.976ZM3 4.5C3 3.30653 3.47411 2.16193 4.31802 1.31802C5.16193 0.474106 6.30653 0 7.5 0C8.69347 0 9.83807 0.474106 10.682 1.31802C11.5259 2.16193 12 3.30653 12 4.5V10.5C12 11.6935 11.5259 12.8381 10.682 13.682C9.83807 14.5259 8.69347 15 7.5 15C6.30653 15 5.16193 14.5259 4.31802 13.682C3.47411 12.8381 3 11.6935 3 10.5V4.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/Mic.1e31879212d23f1e338ec4d1c90a0945.svg";
export { ForwardRef as ReactComponent };